import {createStore, compose, applyMiddleware} from 'redux';
import thunkMiddleware from 'redux-thunk';
import indexReducer from '../indexReducer';
//import loggerMiddleware from 'redux-logger';

const enhancer = compose(
  applyMiddleware(
    thunkMiddleware
    //, loggerMiddleware
  )
);

export default function configureStore(initialState) {
  const store = createStore(indexReducer, initialState, enhancer);
  return store;
}


// WEBPACK FOOTER //
// ./src/store/store.prod.js